export const helpData = [
  {
    _id: 1,
    title: "Upload or Choose Image:",
    description: `Use the
                      "Upload Files" button to add an image or select from your
                      previous uploads.`,
  },
  {
    _id: 2,
    title: "Replace User Image:",
    description: `Click "Click to
                      Replace" to put your chosen image on the card.`,
  },
  {
    _id: 3,
    title: "Customize Text:",
    description: `
                      Edit the text on the
                      card by clicking on it.`,
  },
  {
    _id: 4,
    title: "Save:",
    description: `Save your customizations.`,
  },
  {
    _id: 5,
    title: "Preview:",
    description: `See how your card looks by
                      clicking "Preview."`,
  },
  {
    _id: 6,
    title: "Next:",
    description: `Proceed to the next page to
                      create an event and share the card.`,
  },
];

export const footerNavOne = [
  {
    _id: 1,
    title: "BLOG",
    link: `/blogs`,
  },
  {
    _id: 2,
    title: "ABOUT US",
    link: `/aboutus`,
  },
  {
    _id: 3,
    title: "PRIVACY POLICY",
    link: `/privacyPolicy`,
  },
  {
    _id: 4,
    title: "CONTACT",
    link: `#`,
  },
  {
    _id: 5,
    title: "AI-POWERED",
    link: `/ComingSoon`,
  },
];

export const footerNavTwo = [
  {
    _id: 1,
    title: "HELP CENTER",
    link: `/helpCenter`,
  },
  {
    _id: 2,
    title: "TERMS OF USE",
    link: `/TermOfUse`,
  },
  {
    _id: 3,
    title: `SHIPPING & DELIVERY POLICY`,
    link: `/ShippingNdelivery`,
  },
  {
    _id: 4,
    title: "REFUND PROCESS",
    link: `/refund`,
  },
];

export const footerData = [
  {
    id: 1,
    title: "Blog",
    link: `/blogs`,
  },
  {
    id: 2,
    title: "About Us",
    link: `/aboutus`,
  },
  {
    id: 3,
    title: "Privacy Policy",
    link: `/privacyPolicy`,
  },
  {
    id: 4,
    title: "",
    link: `#`,
  },

  {
    id: 5,
    title: "Plants",
    link: `/plantEcommerce`,
  },
  {
    id: 6,
    title: "Pots",
    link: `/potsAll`,
  },
  {
    id: 7,
    title: "Home Decor",
    link: `/homeDecorAll`,
  },

  {
    id: 8,
    title: "Wishfy Inspiration Board",
    link: `/inspirationCategory`,
  },

  {
    id: 9,
    title: "Help Center",
    link: `/helpCenter`,
  },
  {
    id: 10,
    title: "Terms Of Use",
    link: `/TermOfUse`,
  },
  {
    id: 11,
    title: `Shipping & Delivery`,
    link: `/ShippingNdelivery`,
  },
  {
    id: 12,
    title: "Refund Process",
    link: `/refund`,
  },
  {
    id: 13,
    title: "Contact Us",
    link: `/contact-us`,
  },
];

export const profile_item = [
  {
    label: "https://bit.ly/dan-abramov",
    children: [
      {
        label: "My Greetings",
        href: "/greetings",
      },
      // {
      //   label: "My Invitation",
      //   href: "/invitation",
      // },
      // {
      //   label: "My Gift Diary",
      //   href: "/giftdiaries",
      // },
      // {
      //   label: "My EShagun",
      //   href: "/eshagun",
      // },
      // {
      //   label: "My Events",
      //   href: "/events",
      // },
      // {
      //   label: "My WishList",
      //   href: "/wishlist",
      // },
      // {
      //   label: "My Wishlist",
      //   href: "/my-wishlist",
      // },
      {
        label: "My Orders",
        href: "/myorder",
      },
      // {
      //   label: "My Groups",
      //   href: "/myGroups",
      // },
      {
        label: "My Profile",
        href: "/myprofile",
      },
    ],
  },
];
